/**
 * Random number and other generation utilities
 */

/**
 * Generates a random number within a specified range
 * @param minNum - Minimum value (inclusive, default: 0)
 * @param maxNum - Maximum value (exclusive, default: 1000)
 * @returns Random integer within the specified range
 * @throws Error if minNum >= maxNum
 * @example
 * generateRandomNumber(1, 10) // Random integer from 1 to 9
 * generateRandomNumber() // Random integer from 0 to 999
 */
export const generateRandomNumber = (
  minNum: number = 0,
  maxNum: number = 1000
): number => {
  if (minNum >= maxNum) {
    throw new Error("The 'min' value must be less than the 'max' value.");
  }
  return Math.floor(Math.random() * (maxNum - minNum)) + minNum;
};